export default __webpack_public_path__ + "static/zach-d7fbbd51e3643a8a502c2276eb08d7cd.png";